import { getDraftApplications } from './states';

export const services = {
  getDraftApplications,
};
